import { Feed, Icon, Popup } from "semantic-ui-react";
import moneda from "../../../pipes/moneda";
import moment from "moment";
import "moment/locale/es";
import "./styles.css";
moment.locale("es");

export const crearMensaje = (
  id,
  tipoNotificacion,
  data,
  fecha,
  onActionClick,
  onEliminarNotificacion,
  activo
) => {
  const notificacion = JSON.parse(data);
  switch (tipoNotificacion) {
    case "ASIGNO_PROSPECTO_A_VENDEDOR_INTERO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreEmisor}
            </label>
            {` te asignó el ${tipoClienteEnum[notificacion.tipoCliente]} `}
            <label
              style={{
                color: "green",
              }}
            >
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "REGISTRO_EVENTO_CON_PARTICIPANTES":
    //console.log('notificacion.fechaInicioEvento', notificacion.fechaInicioEvento)
    //console.log('horaZonaActual', horaZonaActual(notificacion.fechaInicioEvento))
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se te asignó el evento "}
            <label style={{ color: "green" }}>
              {notificacion.nombreEvento}
            </label>
            {" el día "}
            <label style={{ color: "green" }}>
              {moment(notificacion.fechaInicioEvento).format("DD/MM/YYYY")}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "PROSPECTO_SIN_VALORACION":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`No olvides valorar al ${
              tipoClienteEnum[notificacion.tipoCliente]
            } `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_TRES_ESTRELLAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Tienes más de 5 días sin contactar a "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" con 3 estrellas reactivalo registrando una actividad."}
          </label>
        </BaseMensaje>
      );

    case "SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_DOS_ESTRELLAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Tienes más de 10 días sin contactar a "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" con 2 estrellas reactivalo registrando una actividad."}
          </label>
        </BaseMensaje>
      );

    case "SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_UNA_ESTRELLAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Tienes más de 15 días sin contactar a "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" con 1 estrellas reactivalo registrando una actividad."}
          </label>
        </BaseMensaje>
      );

    case "REGISTRO_ACTIVIDAD_INTERNA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se te asignó ${tipoActividadEnum[notificacion.tipoActividad]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreActividad}
            </label>
            {" para el día "}
            <label style={{ color: "green" }}>
              {moment(notificacion.fechaActividad).format("DD/MM/YYYY")}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "REGISTRO_ACTIVIDAD_PROSPECTO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se te asignó ${tipoActividadEnum[notificacion.tipoActividad]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreActividad}
            </label>
            {" a "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" para el día "}
            <label style={{ color: "green" }}>
              {moment(notificacion.fechaActividad).format("DD/MM/YYYY")}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_EDITO_ACTIVIDAD_REGISTRADA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreVendedor}
            </label>
            {` modificó ${tipoActividadEnum[notificacion.tipoActividad]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreActividad}
            </label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "LLEGO_FECHA_HORA_ACTIVADAD":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Tienes ${tipoActividadEnum[notificacion.tipoActividad]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreActividad}
            </label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" pendiente de realizar."}
          </label>
        </BaseMensaje>
      );

    case "RECORDATORIO_ACTIVIDAD":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Recordatorio. Tienes ${
              tipoActividadEnum[notificacion.tipoActividad]
            } `}
            <label style={{ color: "green" }}>
              {notificacion.nombreActividad}
            </label>
            {!notificacion.isUsuarioInterno && (
              <>
                {" para "}
                <label style={{ color: "green" }}>
                  {notificacion.nombreProspecto}
                </label>
              </>
            )}
            {" programada para el día "}
            <label style={{ color: "green" }}>
              {moment(notificacion.fechaActividad).format("DD/MM/YYYY")}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "APROBO_DESARROLLO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se aprobó el desarrollo "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" con "}
            <label style={{ color: "green" }}>{notificacion.partidas}</label>
            {" partida(s)."}
          </label>
        </BaseMensaje>
      );

    case "APROBO_PRODUCTO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se aprobó el producto `}
            <label style={{ color: "green" }}>
              {notificacion.codigoProducto}
            </label>
            {` del desarrollo `}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "RECHAZO_DESARROLLO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se rechazó el desarrollo "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" con "}
            <label style={{ color: "green" }}>{notificacion.partidas}</label>
            {" partida(s). "}
          </label>
        </BaseMensaje>
      );

    case "RECHAZO_PRODUCTO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se rechazó el producto `}
            <label style={{ color: "green" }}>
              {notificacion.codigoProducto}
            </label>
            {` del desarrollo `}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {` para `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_AGREGO_PRODUCTOS_A_DESARROLLO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se ha modificado el desarrollo de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto},
            </label>
            {" favor de verificarlo para su aprobación o rechazo."}
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_CANCELO_DESARROLLO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreVendedor}
            </label>
            {" canceló el desarrollo "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "ADMINISTRADOR_CANCELO_DESARROLLO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreEmisor}
            </label>
            {" canceló el desarrollo "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
            {" Mira el motivo en el detalle"}
          </label>
        </BaseMensaje>
      );

    case "DESARROLLO_HA_FINALIZADO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"El desarrollo "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" ha finalizado."}
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_REGISTRO_COTIZACION":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreVendedor}
            </label>
            {" ha generado la cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_CANCELO_COTIZACION":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreVendedor}
            </label>
            {" canceló la cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" para "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "COTIZACION_ESTA_POR_VENCER_DIEZ_DIAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" vence en 10 días."}
          </label>
        </BaseMensaje>
      );

    case "COTIZACION_ESTA_POR_VENCER_CINCO_DIAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" vence en 5 días."}
          </label>
        </BaseMensaje>
      );

    case "COTIZACION_ESTA_POR_VENCER_UN_DIA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" vence mañana."}
          </label>
        </BaseMensaje>
      );

    case "COTIZACION_HA_VENCIDO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" se ha vencido, por lo que su estatus se actualizó a Cancelada."}
          </label>
        </BaseMensaje>
      );

    case "ADMINISTRADOR_CANCELO_COTIZACION":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreEmisor}
            </label>
            {" canceló la cotización "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
            {" Mira el motivo en el detalle"}
          </label>
        </BaseMensaje>
      );

    case "CREA_ORDEN_VENTA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se ha generado la OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {"  a "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_CANCELA_ORDEN_VENTA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreVendedor}
            </label>
            {" canceló la OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "ADMINISTRADOR_CANCELA_ORDEN_VENTA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            <label style={{ color: "green" }}>
              {notificacion.nombreEmisor}
            </label>
            {" canceló la OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.NombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "FACTURACION_CAMBIA_A_FACTURADA_ORDEN_VENTA":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" por "}
            <label style={{ color: "green" }}>
              {moneda(notificacion.importe.toString())}
            </label>
            {" ha sido facturada."}
          </label>
        </BaseMensaje>
      );

    case "FACTURACION_SOLICITA_SALIDA_ORDEN_VENTA_ALMACEN":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se solicita dar salida a la OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "ORDEN_VENTA_ESTATUS_ENTREGADO_O_PARCIAL":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Se han "}
            <label style={{ color: "green" }}>
              {ordenVentaEstatus[notificacion.estatus]}
            </label>
            {" los productos de la OV "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" de "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "CLIENTE_SIN_ACTIVIDAD_REGISTRADA_POR_MAS_DE_TREINTA_DIAS":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"Tienes más de 30 días sin contactar al cliente "}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" reactivalo registrando una actividad o una negociación."}
          </label>
        </BaseMensaje>
      );

    case "GUARDA_FOLIO_FACTURA_DE_ORDEN_VENTA_PAGO_CONTADO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La factura "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {` del ${tipoClienteEnum[notificacion.tipoCliente]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" se ha vencido."}
          </label>
        </BaseMensaje>
      );

    case "GUARDA_FOLIO_FACTURA_DE_ORDEN_VENTA_PAGO_CREDITO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La factura "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {` del ${tipoClienteEnum[notificacion.tipoCliente]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" vence mañana."}
          </label>
        </BaseMensaje>
      );

    case "FECHA_PAGO_FACTURA_HA_VENCIDO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La factura "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {` del ${tipoClienteEnum[notificacion.tipoCliente]} `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}
            </label>
            {" se ha vencido."}
          </label>
        </BaseMensaje>
      );

    case "ORDEN_VENTA_CAMBIA_ESTATUS_A_FACTURACION":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {"La factura "}
            <label style={{ color: "green" }}>{notificacion.folio}</label>
            {" a sido "}
            <label style={{ color: "green" }}>
              {ordenVentaEstatus[notificacion.estatus]}.
            </label>
          </label>
        </BaseMensaje>
      );

    case "ADMINISTRADOR_INACTIVA_PROSPECTO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se ha inactivado al ${
              tipoClienteEnum[notificacion.tipoCliente]
            } `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
            {" Verifica el motivo"}
          </label>
        </BaseMensaje>
      );

    case "VENDEDOR_INACTIVA_PROSPECTO":
      return (
        <BaseMensaje
          tipoNotificacion={tipoNotificacion}
          id={id}
          fecha={fecha}
          onActionClick={onActionClick}
          activo={activo}
          notificacion={notificacion}
          onEliminarNotificacion={onEliminarNotificacion}
        >
          <label>
            {`Se ha inactivado al ${
              tipoClienteEnum[notificacion.tipoCliente]
            } `}
            <label style={{ color: "green" }}>
              {notificacion.nombreProspecto}.
            </label>
            {" Verifica el motivo"}
          </label>
        </BaseMensaje>
      );

    default:
      break;
  }
};

const tipoActividadEnum = {
  0: "una llamada",
  1: "una visita",
  2: "una reunión",
  3: "una tarea",
  4: "una nota",
  5: "un correo",
};

const tipoClienteEnum = {
  0: "prospecto",
  1: "cliente",
  2: "distribuidor",
};

const ordenVentaEstatus = {
  0: "generada",
  1: "enviada",
  2: "cancelada",
  4: "facturada",
  5: "entregado",
  6: "entregado parcial",
};

const horaZonaActual = (valor) => {
  let fecha = new Date(valor);
  let offset = new Date().getTimezoneOffset();
  let diferenciaZonaActual = offset / 60;
  //console.log('fecha inicio', fecha);
  //console.log('diferenciaZonaActual->', diferenciaZonaActual);

  let diferenciaZonaMexico =
    moment.tz.zone('America/Mexico_City').utcOffset(new Date()) / 60;
  //console.log('diferencia mexico', diferenciaZonaMexico);
  let restarHora = diferenciaZonaActual - diferenciaZonaMexico;
  let utcHour = fecha.getUTCHours();
  //console.log('utcHour', utcHour)
  fecha.setHours(utcHour - restarHora);
  return fecha;
};

const BaseMensaje = (props) => {
  const {
    tipoNotificacion,
    id,
    fecha,
    onActionClick,
    onEliminarNotificacion,
    activo,
    notificacion,
    children = null,
  } = props;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, textAlign: "right" }}>
        <Popup
          content="Eliminar"
          trigger={
            <Icon
              className="eliminarNotificacion"
              name="close"
              style={{ cursor: "pointer" }}
              onClick={() => onEliminarNotificacion(id)}
            />
          }
        ></Popup>
      </div>
      <div
        style={{
          flex: 1,
          paddingBottom: "1vw",
          paddingLeft: "1vw",
          paddingRight: "1vw",
        }}
      >
        <Feed onClick={() => onActionClick(tipoNotificacion, id, notificacion)}>
          <Feed.Event>
            <Feed.Content>
              <Feed.Date>
                <Feed.Content>{moment(fecha).fromNow()}</Feed.Content>
              </Feed.Date>
              <Feed.Summary>{children}</Feed.Summary>
            </Feed.Content>
          </Feed.Event>
        </Feed>
      </div>
    </div>
  );
};
